import React, { createContext, useState, useContext, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    //=======================================
    // FUNCION PARA INICIAR SESION
    //=======================================

    const logIn = ( data ) => {
        const expires = new Date();
        expires.setDate( expires.getDate() + 1 );
        const size = new Blob([data.menu]).size;
        if (size > 4096) {
            console.log("MENU TOO BIG");
        }
        Cookies.set('ebt_token', data.token, { expires });
        Cookies.set('ebt_id_user', data.user, { expires });
        Cookies.set('ebt_nombre', data.nombre, { expires });
        //Cookies.set('ebt_menu', data.menu, { expires });
        localStorage.setItem('ebt_menu', data.menu);
        Cookies.set('ebt_perfil', data.perfil, { expires });

        setIsLoggedIn(true)

    };

    //=======================================
    // FUNCION PARA CERRAR SESION
    //=======================================

    const logOut = () => {

        Cookies.remove('ebt_token');
        Cookies.remove('ebt_id_user');
        Cookies.remove('ebt_nombre');
        Cookies.remove('ebt_perfil');
        //Cookies.remove('ebt_menu');
        localStorage.removeItem('ebt_menu');
        setIsLoggedIn(false);

    };

    //=======================================
    // USE EFFECT PARA VALIDAR TOKEN
    //=======================================

    useEffect(() => {
        

        const token = Cookies.get('ebt_token');

        if(!token){

            logOut()

        } else {

            setIsLoggedIn(true)

        }

    }, []);

    // =============================================

    return (

        <AuthContext.Provider value={{ isLoggedIn, logIn, logOut}}>
            { children }
        </AuthContext.Provider>

    )

}

export const useAuth = () => useContext(AuthContext);

export default AuthProvider